module.exports = __webpack_public_path__ + "static/media/image_54.6daa38b7.png";